// HKDSE 2025 Paper 1 Knowledge Graph Samples - Complete Set
// Organized by question types with systematic naming

export const hkdse2025Samples_complete = {
  algebra: [
    {
      id: 'hkdse2025_algebra_01',
      problem: "化简 $\\frac{(x^4 y^{-5})^3}{xy^2}$，并以正指数表示答案。",
      problemType: "algebra_indices",
      difficulty: "intermediate",
      description: "Simplifying expressions with negative indices",
      graphData: {
        nodes: [
          {
            id: "negative_indices",
            name: "Negative Indices",
            type: "concepts",
            description: "Understanding negative indices and their properties",
            value: "a⁻ⁿ = 1/aⁿ",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "power_of_power",
            name: "Power of Power",
            type: "concepts",
            description: "(aᵐ)ⁿ = aᵐⁿ",
            value: "(x⁴y⁻⁵)³ = x¹²y⁻¹⁵",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "division_of_powers",
            name: "Division of Powers",
            type: "methods",
            description: "aᵐ/aⁿ = aᵐ⁻ⁿ",
            value: "x¹²y⁻¹⁵/(xy²) = x¹¹y⁻¹⁷",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "positive_index_form",
            name: "Positive Index Form",
            type: "concepts",
            description: "Converting to positive index form",
            value: "x¹¹/y¹⁷",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "negative_indices",
            to: "power_of_power",
            type: "applied_to",
            strength: 9
          },
          {
            from: "power_of_power",
            to: "division_of_powers",
            type: "enables",
            strength: 9
          },
          {
            from: "division_of_powers",
            to: "positive_index_form",
            type: "converts_to",
            strength: 8
          }
        ]
      }
    },
    {
      id: 'hkdse2025_algebra_02',
      problem: "化简 $\\frac{1}{3d-4} - \\frac{2}{6d+5}$。",
      problemType: "algebra_fractions",
      difficulty: "intermediate",
      description: "Simplifying algebraic fractions",
      graphData: {
        nodes: [
          {
            id: "fraction_subtraction",
            name: "Fraction Subtraction",
            type: "concepts",
            description: "Subtracting two algebraic fractions",
            value: "1/(3d-4) - 2/(6d+5)",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "common_denominator",
            name: "Common Denominator",
            type: "methods",
            description: "Finding common denominator",
            value: "LCD = (3d-4)(6d+5)",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "numerator_expansion",
            name: "Numerator Expansion",
            type: "methods",
            description: "Expanding numerators",
            value: "1(6d+5) - 2(3d-4)",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "simplified_form",
            name: "Simplified Form",
            type: "concepts",
            description: "Final simplified expression",
            value: "Simplified result",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "fraction_subtraction",
            to: "common_denominator",
            type: "requires",
            strength: 9
          },
          {
            from: "common_denominator",
            to: "numerator_expansion",
            type: "enables",
            strength: 9
          },
          {
            from: "numerator_expansion",
            to: "simplified_form",
            type: "results_in",
            strength: 8
          }
        ]
      }
    }
  ],
  ratios: [
    {
      id: 'hkdse2025_ratios_01',
      problem: "设 $m$ 及 $n$ 为两数。$2m$ 与 $3n$ 之和为 $999$ 而 $m$ 与 $n$ 之比为 $8:7$。求 $n$。",
      problemType: "ratios_proportion",
      difficulty: "intermediate",
      description: "Working with ratios and proportions",
      graphData: {
        nodes: [
          {
            id: "sum_equation",
            name: "Sum Equation",
            type: "concepts",
            description: "2m + 3n = 999",
            value: "2m + 3n = 999",
            importance: 9,
            x: -200, y: -200, z: 0
          },
          {
            id: "ratio_relationship",
            name: "Ratio Relationship",
            type: "concepts",
            description: "m:n = 8:7",
            value: "m/n = 8/7",
            importance: 9,
            x: 200, y: -200, z: 0
          },
          {
            id: "variable_relationships",
            name: "Variable Relationships",
            type: "methods",
            description: "Expressing variables in terms of one variable",
            value: "m = 8k, n = 7k",
            importance: 8,
            x: 0, y: 0, z: 0
          },
          {
            id: "variable_n",
            name: "Variable n",
            type: "variables",
            description: "n to be found",
            value: "n",
            importance: 10,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "sum_equation",
            to: "variable_relationships",
            type: "provides_constraint",
            strength: 9
          },
          {
            from: "ratio_relationship",
            to: "variable_relationships",
            type: "provides_constraint",
            strength: 9
          },
          {
            from: "variable_relationships",
            to: "variable_n",
            type: "solves_for",
            strength: 10
          }
        ]
      }
    }
  ],
  coordinate_geometry: [
    {
      id: 'hkdse2025_coordinate_geometry_01',
      problem: "点 $A$ 的坐标为 $(4, -2)$。$A$ 绕原点 $O$ 顺时针方向旋转 $90°$ 至 $B$。(a) 写出 $B$ 的坐标。(b) 假定 $B$ 向上平移 $t$ 单位至点 $C$。若 $A$、$O$ 与 $C$ 共线，求 $t$。",
      problemType: "coordinate_geometry_rotation_translation",
      difficulty: "intermediate",
      description: "Working with rotation and translation in coordinate geometry",
      graphData: {
        nodes: [
          {
            id: "rotation_90_clockwise",
            name: "Rotation 90° Clockwise",
            type: "methods",
            description: "Rotating point 90° clockwise about origin",
            value: "(x,y) → (y,-x)",
            importance: 9,
            x: -200, y: -200, z: 0
          },
          {
            id: "translation_up",
            name: "Translation Up",
            type: "methods",
            description: "Translating point upward by t units",
            value: "(x,y) → (x,y+t)",
            importance: 8,
            x: 200, y: -200, z: 0
          },
          {
            id: "collinearity_condition",
            name: "Collinearity Condition",
            type: "concepts",
            description: "A, O, C are collinear",
            value: "Points lie on same line",
            importance: 8,
            x: 0, y: 0, z: 0
          },
          {
            id: "translation_distance",
            name: "Translation Distance",
            type: "variables",
            description: "t to be determined",
            value: "t",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "rotation_90_clockwise",
            to: "translation_up",
            type: "enables",
            strength: 8
          },
          {
            from: "translation_up",
            to: "collinearity_condition",
            type: "constrains",
            strength: 8
          },
          {
            from: "collinearity_condition",
            to: "translation_distance",
            type: "determines",
            strength: 7
          }
        ]
      }
    }
  ],
  factorization: [
    {
      id: 'hkdse2025_factorization_01',
      problem: "因式分解 (a) $10pr - 6qr$，(b) $25p^2 - 9q^2$，(c) $25p^2 - 9q^2 - 10pr + 6qr$。",
      problemType: "factorization_common_factor_difference_squares",
      difficulty: "intermediate",
      description: "Factorizing using common factors and difference of squares",
      graphData: {
        nodes: [
          {
            id: "common_factor",
            name: "Common Factor",
            type: "methods",
            description: "Extracting common factor",
            value: "10pr - 6qr = 2r(5p - 3q)",
            importance: 9,
            x: -200, y: -200, z: 0
          },
          {
            id: "difference_squares",
            name: "Difference of Squares",
            type: "methods",
            description: "a² - b² = (a+b)(a-b)",
            value: "25p² - 9q² = (5p+3q)(5p-3q)",
            importance: 9,
            x: 200, y: -200, z: 0
          },
          {
            id: "combining_factors",
            name: "Combining Factors",
            type: "methods",
            description: "Combining results from (a) and (b)",
            value: "Use results from (a) and (b)",
            importance: 8,
            x: 0, y: 0, z: 0
          },
          {
            id: "final_factorization",
            name: "Final Factorization",
            type: "concepts",
            description: "Complete factorization of (c)",
            value: "Final factored form",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "common_factor",
            to: "combining_factors",
            type: "provides",
            strength: 9
          },
          {
            from: "difference_squares",
            to: "combining_factors",
            type: "provides",
            strength: 9
          },
          {
            from: "combining_factors",
            to: "final_factorization",
            type: "results_in",
            strength: 8
          }
        ]
      }
    }
  ],
  inequalities: [
    {
      id: 'hkdse2025_inequalities_01',
      problem: "考虑复合不等式 $\\frac{6x+1}{2} < x - 8$ 或 $3x \\leq -21$ ............(*)。(a) 解 (*)。(b) 写出满足 (*) 的最大整数。",
      problemType: "inequalities_compound",
      difficulty: "intermediate",
      description: "Solving compound inequalities with 'or'",
      graphData: {
        nodes: [
          {
            id: "first_inequality",
            name: "First Inequality",
            type: "concepts",
            description: "(6x+1)/2 < x - 8",
            value: "(6x+1)/2 < x - 8",
            importance: 9,
            x: -200, y: -200, z: 0
          },
          {
            id: "second_inequality",
            name: "Second Inequality",
            type: "concepts",
            description: "3x ≤ -21",
            value: "3x ≤ -21",
            importance: 8,
            x: 200, y: -200, z: 0
          },
          {
            id: "compound_inequality",
            name: "Compound Inequality",
            type: "concepts",
            description: "Inequality with 'or' condition",
            value: "First OR Second",
            importance: 9,
            x: 0, y: 0, z: 0
          },
          {
            id: "largest_integer",
            name: "Largest Integer",
            type: "concepts",
            description: "Largest integer in solution set",
            value: "Find largest integer satisfying (*)",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "first_inequality",
            to: "compound_inequality",
            type: "part_of",
            strength: 9
          },
          {
            from: "second_inequality",
            to: "compound_inequality",
            type: "part_of",
            strength: 8
          },
          {
            from: "compound_inequality",
            to: "largest_integer",
            type: "constrains",
            strength: 7
          }
        ]
      }
    }
  ],
  word_problems: [
    {
      id: 'hkdse2025_word_problems_01',
      problem: "某纪念品的售价为 $378。该纪念品以其标价四折售出。该纪念品的标价较其成本高 $75\\%$。(a) 求该纪念品的标价。(b) 求该纪念品的成本。(c) 判别售出该纪念品后是获利还是亏蚀。试解释你的答案。",
      problemType: "word_problems_percentage_profit_loss",
      difficulty: "intermediate",
      description: "Solving percentage and profit/loss problems",
      graphData: {
        nodes: [
          {
            id: "selling_price",
            name: "Selling Price",
            type: "concepts",
            description: "Actual selling price",
            value: "Selling price = $378",
            importance: 9,
            x: -200, y: -200, z: 0
          },
          {
            id: "discount_relationship",
            name: "Discount Relationship",
            type: "concepts",
            description: "Sold at 40% of marked price",
            value: "Selling price = 0.4 × Marked price",
            importance: 9,
            x: 200, y: -200, z: 0
          },
          {
            id: "markup_relationship",
            name: "Markup Relationship",
            type: "concepts",
            description: "Marked price 75% higher than cost",
            value: "Marked price = Cost × 1.75",
            importance: 8,
            x: 0, y: 0, z: 0
          },
          {
            id: "profit_loss_analysis",
            name: "Profit/Loss Analysis",
            type: "concepts",
            description: "Determining profit or loss",
            value: "Compare selling price with cost",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "selling_price",
            to: "discount_relationship",
            type: "provides_equation",
            strength: 9
          },
          {
            from: "discount_relationship",
            to: "markup_relationship",
            type: "enables",
            strength: 8
          },
          {
            from: "markup_relationship",
            to: "profit_loss_analysis",
            type: "enables",
            strength: 8
          }
        ]
      }
    }
  ],
  geometry: [
    {
      id: 'hkdse2025_geometry_01',
      problem: "图中，$ST$ 与 $UY$ 相交于点 $W$。已知 $SU \\parallel VT$ 及 $W$ 为 $ST$ 的中点。Figure description: A geometric diagram showing two intersecting lines ST and UY meeting at point W. There are additional points S, T, U, V forming what appears to be a geometric configuration where SU is parallel to VT and W is the midpoint of ST. (a) 证明 $\\triangle SUW \\cong \\triangle TVW$。(b) 设 $X$ 为 $TW$ 上的一点使得 $\\triangle SUW \\sim \\triangle VXW$。若 $SU = 57$ cm，$SW = 63$ cm 及 $WX = 7$ cm，求 $\\triangle TVX$ 的周界。",
      problemType: "geometry_congruence_similarity",
      difficulty: "intermediate",
      description: "Working with congruent and similar triangles",
      graphData: {
        nodes: [
          {
            id: "parallel_lines",
            name: "Parallel Lines",
            type: "concepts",
            description: "SU parallel to VT",
            value: "SU ∥ VT",
            importance: 9,
            x: -200, y: -200, z: 0
          },
          {
            id: "midpoint_property",
            name: "Midpoint Property",
            type: "concepts",
            description: "W is midpoint of ST",
            value: "W is midpoint of ST",
            importance: 9,
            x: 200, y: -200, z: 0
          },
          {
            id: "congruent_triangles",
            name: "Congruent Triangles",
            type: "concepts",
            description: "△SUW ≅ △TVW",
            value: "Triangles are congruent",
            importance: 10,
            x: 0, y: 0, z: 0
          },
          {
            id: "triangle_perimeter",
            name: "Triangle Perimeter",
            type: "concepts",
            description: "Perimeter of △TVX",
            value: "Calculate perimeter using given dimensions",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "parallel_lines",
            to: "congruent_triangles",
            type: "proves",
            strength: 9
          },
          {
            from: "midpoint_property",
            to: "congruent_triangles",
            type: "proves",
            strength: 9
          },
          {
            from: "congruent_triangles",
            to: "triangle_perimeter",
            type: "enables",
            strength: 8
          }
        ]
      }
    }
  ]
}; 